import { render, staticRenderFns } from "./boutique.vue?vue&type=template&id=fcbc98d4&scoped=true"
import script from "./boutique.vue?vue&type=script&lang=js"
export * from "./boutique.vue?vue&type=script&lang=js"
import style0 from "./boutique.vue?vue&type=style&index=0&id=fcbc98d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbc98d4",
  null
  
)

export default component.exports